import React, { useContext } from 'react'
import Dropdown from 'components/Dropdown'
import { LaunchSketchAlert } from 'containers/modals/LaunchSketchAlert'
import { ModalContext } from 'containers/ModalManager'
import { ShareInfoFragment, VersionFragment } from 'gqlTypes'
import { DownloadProps } from 'modules/shares/utils'

export interface ShareForDownloadOptions
  extends Pick<
    ShareInfoFragment,
    | 'libraryEnabled'
    | 'userCanUpdateSettings'
    | 'identifier'
    | 'userCanContribute'
  > {}

interface VersionForShareDropdown {
  currentVersion: VersionFragment | null
  latestVersion: VersionFragment | null
}

interface DownloadOptionsProps {
  share: ShareForDownloadOptions
  download: DownloadProps
  version: VersionForShareDropdown
  isViewingLatestVersion?: boolean
}

const DownloadOptions: React.FC<DownloadOptionsProps> = ({
  share,
  version,
  download,
  isViewingLatestVersion,
}) => {
  const { showModal } = useContext(ModalContext)

  const showDownloadItem =
    version.currentVersion?.document?.downloadAvailable || false
  const showLibraryItem = share.libraryEnabled
  const showOpenInSketchItem =
    version.currentVersion?.document?.userCanOpenInApp || false

  if (!showDownloadItem && !showLibraryItem && !showOpenInSketchItem) {
    return null
  }

  return (
    <>
      {showOpenInSketchItem && isViewingLatestVersion && (
        <Dropdown.Item
          onClick={() =>
            showModal(LaunchSketchAlert, {
              shareId: share.identifier,
              action: 'openInSketch',
            })
          }>
          Edit
        </Dropdown.Item>
      )}

      {showDownloadItem && (
        <Dropdown.Download href={download.url}>Download</Dropdown.Download>
      )}

      {showLibraryItem && (
        <Dropdown.Item
          onClick={() =>
            showModal(LaunchSketchAlert, {
              shareId: share.identifier,
              action: 'addLibrary',
            })
          }>
          Add Library
        </Dropdown.Item>
      )}
    </>
  )
}

export default DownloadOptions
